import { createAxiosInstance } from './createAxiosInstance';

export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const axiosRequest = createAxiosInstance(BASE_URL);
export const axiosRequestEvents = createAxiosInstance(process.env.REACT_APP_BASE_URL_EVENTS);
// Risk context queries can wait on DB connect (20s) + heavy SQL — allow enough headroom.
export const axiosRequestRisks = createAxiosInstance(process.env.REACT_APP_BASE_URL_RISKS, {
  timeout: 60_000,
});
